import React from "react";
import equal from "fast-deep-equal/es6";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { duration } from "@formant/core/model/duration";

import { appStore, observeStore } from "../../../stores";
import { BaseListModule } from "../BaseListModule";
import { IMetadataDataPoint } from "../utils/IMetadataDataPoint";
import { TextModuleListItem } from "./TextModuleListItem";

@observer
export class TextModule extends BaseListModule<"text"> {
    protected type: "text" = "text";

    protected listItem = (point: IMetadataDataPoint<"text">, i: number) => {
        const { selected: selectedDataPoint, onClick } = this;
        const { hideDevice } = this.props;
        const { mode, time } = observeStore;

        const selected =
            // When paused, the selected row is the clicked row.
            (mode === "pause" && equal(selectedDataPoint, point)) ||
            // When not paused, the selected row is the first row
            // (but only if activated by selecting any row first).
            (mode !== "pause" && i === 0 && !!selectedDataPoint);

        return (
            <TextModuleListItem
                key={i}
                point={point}
                old={
                    point.time.getTime() < time.getTime() - 5 * duration.second
                }
                live={mode === "live"}
                hideDevice={hideDevice}
                utc={appStore.utc}
                onClick={onClick}
                selected={selected}
            />
        );
    };

    @observable
    private selected: IMetadataDataPoint<"text"> | undefined = undefined;

    private onClick = (point: IMetadataDataPoint<"text">) => {
        // Toggle row selection when clicked - except if there is selected text
        if (window.getSelection()?.type === "Range") {
            return;
        }
        this.selected = equal(this.selected, point) ? undefined : point;
        observeStore.mode = "pause";
    };
}
